export default __webpack_public_path__ + "static/media/image.friends-of-whales.c07813a9.png";